import { Form, Input, InputNumber } from 'antd';

type FixedFormFieldsProps = {
  subjectId: string;
  centerId: string;
  ip?: string;
  // Optional override for the section heading text. Defaults to the
  // original "Form Information" so every other form type (SAE_AESI,
  // PREGNANCY, ADVERSE_EVENTS) keeps rendering exactly as it did before -
  // only CIOMS passes an explicit "FORM INFORMATION" (all caps).
  title?: string;
};

const FixedFormFields = ({
  subjectId,
  centerId,
  ip,
  title = 'Form Information',
}: FixedFormFieldsProps) => {
  return (
    <>
      <h2>{title}</h2>
      <Form.Item label="Subject">
        <Input value={subjectId} disabled />
      </Form.Item>
      <Form.Item label="Center">
        <Input value={centerId} disabled />
      </Form.Item>
      <Form.Item label="SAE Number" name="saeNumber">
        <InputNumber
          placeholder="Enter SAE Number"
          style={{ width: '100%' }}
          min={1}
          precision={0}
        />
      </Form.Item>
      {ip && (
        <Form.Item label="IP">
          <Input value={ip} disabled />
        </Form.Item>
      )}
    </>
  );
};

export default FixedFormFields;
